import * as React from 'react';

const EGDSLayoutItem = (props) => {
    const { children, className } = props;
    const childrenArray = React.Children.toArray(children);
    if (!childrenArray.length) {
        return null;
    }
    const firstChild = childrenArray[0];
    const decoratedChild = React.cloneElement(firstChild, {
        className,
    });
    return decoratedChild;
};

export { EGDSLayoutItem as E };
//# sourceMappingURL=index-chunk.esm.js.map
